import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f0b67e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "default-layout" }
const _hoisted_2 = { class: "default-layout__content page-container" }

import MainHeader from '@C/layout/MainHeader.vue'

const __default__ = { name: 'LayoutDefault' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainHeader, { class: "default-layout__header" }),
    _createElementVNode("main", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})